import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const SetoresIlpis = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>

                    <HeaderVerde texto="INSTITUCIONALIZADOS" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Capacidade Máxima" nome="capacidade" modulo={modulo} index={n}
                            widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <HeaderVerde texto="Quantitativo" />
                        <Input label="Qtd total no Dia da Inspeção" nome="numero" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Masculino" nome="masculino" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Feminino" nome="feminino" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Não Idosos" nome="idosos" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Acamados" nome="acamados" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Cadeirantes" nome="cadeirantes" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Amputados" nome="amputados" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />

                    </div>

                    <HeaderVerde texto="GRAU DE DEPENDÊNCIA DOS INSTITUCIONALIZADOS" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Grau I - Idosos Independentes" nome="grauI" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Grau II - Idosos com Dependência em até Três Atividades de Autocuidado" nome="grauII" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Grau III - Idosos Totalmente Dependentes" nome="grauIII" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />

                    </div>

                    <HeaderVerde texto="EQUIPE TÉCNICA NA ASSISTÊNCIA" />

                    <CheckContainer>
                        <CheckBox texto="Médico" grupo="setoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="7vw" />
                        <CheckBox texto="Psicólogo" grupo="setoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Fonoaudiólogo" grupo="setoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Técnico de Enfermagem" grupo="setoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Terapeuta Ocupacional" grupo="setoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Profissional da Educação física" grupo="setoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Assistente Social" grupo="setoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Enfermeiro" grupo="setoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Fisioterapeuta" grupo="setoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Nutricionista" grupo="setoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Outro profissional" grupo="setoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                    </CheckContainer>
                    
                    <HeaderVerde texto="ATIVIDADES DA INSTITUIÇÃO" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Atividade Física, Recreativa ou Cultural" nome="atividadelazer" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Atividades na Comunidade Local" nome="comunidade" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Atividades Conjuntas com Pessoas de Outras Gerações" nome="atividadeconjunta" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Participação da Família no Cuidado" nome="familia" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Participação da Comunidade no Cuidado" nome="comunidade" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Outras Atividades" nome="outrasatividades" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>


                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Descrição da Legislação Regional" nome="legislacao" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="60vw" widthMobile="80vw" marginR="3vw" />
                        <Select label="CUMPRIMENTO DA LEGISLAÇÃO" nome="resolucao444" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="60vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não", "Não há legislação regional"]} />
                    </div>

                </Caixa>
            )
        }
        return partes
    }
}

export default SetoresIlpis